export const dropDownTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const chevronDownStyle = {
    width: 18,
    height: 20,
    verticalAlign: 'middle',
    marginLeft: 10,
    marginRight: 5,
    fill: '#414141'
};

export const listContainerStyle = {
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
    flexDirection: 'column',
    position: 'absolute',
    zIndex: 10,
    padding: '16px 0 10px 0',
    backgroundColor: '#FFFFFF',
    marginTop: -15,
    userSelect: 'none'
};

export const itemStyle = {
    display: 'flex'
};

export const itemColStyle = {
    padding: '4px 4px 4px 4px'
};

export const itemCol1Style = {
    ...itemColStyle
};

export const itemCol2Style = {
    ...itemColStyle,
    flex: 1
};

export const itemCol3Style = {
    ...itemColStyle
};

export const itemTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500,
    cursor: 'pointer'
};
